import moment from 'moment-timezone';

/**
 * Returns 7 consecutive `moment` objects representing the week around the
 * given `day`. Week starts on Sunday for en-US locales, on Monday for
 * everything else. Used to render the PersonalTimeline day columns.
 *
 * Reads `Intl.DateTimeFormat().resolvedOptions().locale` for the locale.
 */
export const getWeekArrayFromMoment = (day, timezone) => {
	const weekRange = [];

	const userLocale = Intl.DateTimeFormat().resolvedOptions().locale || 'en-US';
	const isUSLocale = userLocale.startsWith('en-US');
	let currentDay = day.clone().tz(timezone).locale(userLocale);

	if (isUSLocale) {
		currentDay = currentDay.startOf('week');
	} else {
		currentDay = currentDay.isoWeekday(1).startOf('day');
	}

	for (let i = 0; i < 7; i++) {
		weekRange.push(moment(currentDay).clone());
		currentDay.add(1, 'day');
	}
	return weekRange;
};
